import { Checkbox, Grid } from "@mui/material";

export const SelectAlmacenes = ({
  almacenes,
  almaSelected,
  setAlmaSelected,
  setDistributionConfig,
  distributionConfig
}) => {
  const handleSelectAlmacen = (id) => {
    if (almaSelected.some((alma) => alma.id === id)) {
      setAlmaSelected(almaSelected.filter((alma) => alma.id !== id));
      setDistributionConfig(distributionConfig.filter((config) => config.alma_id !== id));
    } else {
      const almacen = almacenes.find((alma) => alma.id === id);
      setAlmaSelected([...almaSelected, almacen]);
      setDistributionConfig([...distributionConfig, { alma_id: id, pp_alma_order: almaSelected.length + 1, distribucion: [] }]);
    }
  };

  return (
    <Grid container spacing={0}>
      {almacenes.map((almacen) => (
        <Grid
          item
          key={almacen.id}
          xs={3}
          sx={{ p: 1 }}
          className="center_item"
        >
          <div
            style={{
              width: "100%",
              height: "100px",
              backgroundColor: "#f0f0f0",
              borderRadius: "8px",
              border: "2px solid #bcbcbc",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Checkbox
                checked={almaSelected.some((alma) => alma.id === almacen.id)}
                onChange={() => handleSelectAlmacen(almacen.id)}
                slotProps={{
                  input: { "aria-label": "controlled" },
                }}
              />
              {almaSelected.some((alma) => alma.id === almacen.id) ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0px 15px",
                  }}
                >
                  <span>{almaSelected.indexOf(almacen) + 1}</span>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "start",
                flexGrow: 1,
              }}
            >
              <span
                style={{
                  color: "#575E3B",
                  fontWeight: 600,
                }}
              >
                {almacen.label}
              </span>
            </div>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
